export const stepConstants = {
    GET_STEP_REQUEST: 'GET_STEP_REQUEST',
    GET_STEP_SUCCESS: 'GET_STEP_SUCCESS',
    GET_STEP_FAILURE: 'GET_STEP_FAILURE',

    CLEAR_STEP: 'STEP_CLEAR'
};